<div class="table-content">
  <div class="table-content-header">
    <div
      class="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-sm-center align-items-start pl-4 pr-4 pt-4 pb-4"
    >
      <div>
        <div class="count">
          <span [qcId]="'totalcount-span'" class="count-number text-black">{{
            gridView.totalCount
          }}</span>
          <span [qcId]="'count-title-span'" class="count-title">أسباب</span>
        </div>
      </div>
      <div class="ml-auto">
        <div class="input-group search-group">
          <input
            [qcId]="'search-btn'"
            type="text"
            #inputRef
            class="form-control"
            (keyup.enter)="refresh(1)"
            [(ngModel)]="this.searchModel.keyWord"
            placeholder="بحث"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table [qcId]="'reason-table'" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">{{ "Reasons.ReasonText" | translate }}</th>
          <th scope="col">{{ "Reasons.Status" | translate }}</th>
          <th scope="col">{{ "Reasons.Type" | translate }}</th>
          <th scope="col">{{ "Reasons.CreationDate" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody [qcId]="'table-body'">
        <tr [qcId]="'table-row-no-data'" *ngIf="gridView?.items?.length === 0">
          <td [qcId]="'no-data'" class="text-center" colspan="8">
            <span
              ><b>{{ "Global.NoResult" | translate }}</b></span
            >
          </td>
        </tr>
        <tr [qcId]="'table-row'" *ngFor="let item of gridView?.items">
          <td [qcId]="'row-col-desc'">{{ item.description }}</td>
          <td [qcId]="'row-col-status'">
            <span class="badge" [ngClass]="item.activeStatus">
              {{ "Global." + item.activeStatus | translate }}
            </span>
          </td>
          <td [qcId]="'row-col-type'">{{ item.reasonTypeText }}</td>
          <td [qcId]="'row-col-date'">{{ item.creationDate | date : "yyyy/MM/dd" }}</td>
          <td [qcId]="'row-col-buttons'">
            <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
              <button
              [qcId]="'row-col-buttons-toggle'"
                type="button"
                class="btn btn-default me-2"
                id="dropdownManual"
                ngbDropdownToggle
              >
                <i class="fa-solid fa-ellipsis"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button
                [qcId]="'row-col-buttons-toggle-edit'"
                  ngbDropdownItem
                  (click)="update(item.id)"
                  *ngIf="checkPermission('Pages.Reason.Update')"
                >
                  <i class="fa-regular fa-eye"></i>
                  <span>تعديل السبب</span>
                </button>
                <div *ngIf="checkPermission('Pages.Reason.DeActivate')">
                  <button
                  [qcId]="'row-col-buttons-toggle-deactivated'"
                    ngbDropdownItem
                    *ngIf="item.activeStatus === 'Active'"
                    (click)="deactivate(item.id)"
                  >
                    <i class="fa-solid fa-xmark-large"></i>
                    <span>تعطيل السبب</span>
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-content-footer">
      <div class="d-flex justify-content-between p-2">
        <div class="show-results d-flex align-items-center">
          <span>اظهر </span>
          <select
          [qcId]="'page-size-select'"
            class="form-select form-control"
            [(ngModel)]="pageSize"
            (ngModelChange)="onPageSizechange()"
          >
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <span>نتائج</span>
        </div>
        <ngb-pagination
          [collectionSize]="gridView?.totalCount"
          [(page)]="gridView.pageNumber"
          [pageSize]="gridView.pageSize"
          [maxSize]="10"
          (pageChange)="refresh($event)"
          [rotate]="true"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
